import styled from "styled-components";
import { colorMixin, typographyMixin } from "../../helpers";
import { IColorProps } from "./types";

const colorProp = (colorKey: keyof IColorProps) => (colorProps: IColorProps) => colorMixin(colorProps[colorKey]);

export const Badge = styled.div<IColorProps>`
    display: flex;
    width: fit-content;
    max-width: 100%;
    align-items: center;
    height: 20px;
    border-radius: 10px;
    padding: 0 8px;
    background: ${colorProp("bgColor")};
    color: ${colorProp("color")};
    gap: 4px;
    flex-wrap: nowrap;
    overflow: hidden;

    svg {
        width: 12px;
        stroke: ${colorProp("iconColor")};
    }
`;

export const Text = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${typographyMixin("label-x-small-medium")};
`;
